<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ date.label }}</mat-label>

  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="control"
    [placeholder]="date.label"
    [min]="date.isFutureDateSelected ? today : null"
    [max]="date.isPastDateSelected ? today : null"
    (click)="picker.open()"
    required="{{ date.isRequired }}"
  />

  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>

  @if (control.hasError('required')) {
  <mat-error>
    {{ date.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  }
  <!-- Past time not allowed -->
  @if (control.hasError('pastDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.past-time-not-allowed' | translate }}
  </mat-error>
  }

  <!-- Future time not allowed -->
  @if (control.hasError('futureDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.future-time-not-allowed' | translate }}
  </mat-error>
  }
</mat-form-field>
